const FooterBanner = () => (
  <div className='App-footer flex flex-col items-end justify-end'>
    <p className='text-gray-400 text-xs md:text-sm'>
      Made with 💙 using ⨊(react, tailwind)
    </p>
  </div>
);

export default FooterBanner;
